module.exports = __webpack_public_path__ + "static/img/hotelface.a69cfc5.png";


//////////////////
// WEBPACK FOOTER
// ./static/Brand/BrandBk/hotelface.png
// module id = 1116
// module chunks = 18